import axios from 'axios';
import { infoStore } from '../store/infoStore';
import { useCallback } from 'react';
import { createBaseParams, getApiEndPoint } from '../utils';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const eventBase = `${getApiEndPoint()}/api-gateway`;
const API_URL = {
  eventInfo: `${eventBase}/nhapi/tnmt/event`,
  getTicket: `${eventBase}/neapi/tnmt/event/ticket`,
  agreePrivacy: `${eventBase}/nhapi/tnmt/event/agree`,
  usedTicket: `${eventBase}/nhapi/tnmt/event/pass`,
};

const ENTRY_GROUP_SRL = 15;
export const useApiHook = () => {
  const { setInfo } = infoStore();

  const getEventInfo = useCallback(async () => {
    try {
      const res = await axios.post(API_URL.eventInfo, createBaseParams(ENTRY_GROUP_SRL));
      setInfo(res.data.data);
      return res.data.data;
    } catch (e) {
      alert('에러가 발생 했습니다. 잠시 후 다시 시도해 주세요.');
      setInfo({
        entryGroupSrl: 12,
        status: 3,
        ticketCnt: 0,
        userTicketInfo: [],
        allowDuplicateIssue: 'Y',
        ticketUseYn: 'N',
        ticketPassword: null,
      });
      console.log(e);
    }
  }, [setInfo]);

  const ticketUse = async (ticketNumber: number) => {
    try {
      const response = await axios.post(
        API_URL.usedTicket,
        createBaseParams(ENTRY_GROUP_SRL, ticketNumber),
      );

      return response.data.data;
    } catch (e) {
      alert('에러가 발생 했습니다. 잠시 후 다시 시도해 주세요.');
      console.log(e);
    }
  };

  return { getEventInfo, ticketUse };
};
